import { Link, useNavigate } from 'react-router-dom'
import { ShieldX, ArrowLeft, Home } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useLocalization } from '@/contexts/LocalizationContext'

export function AccessDeniedPage() {
  const { t } = useLocalization()
  const navigate = useNavigate()

  const handleGoBack = () => {
    if (window.history.length > 2) {
      navigate(-1)
    } else {
      navigate('/')
    }
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="mx-auto max-w-md px-4 text-center">
        <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-red-100">
          <ShieldX className="h-12 w-12 text-red-600" />
        </div>

        <h1 className="mb-2 text-4xl sm:text-6xl font-bold text-gray-900">
          {t('errors.accessDeniedCode')}
        </h1>

        <h2 className="mb-3 sm:mb-4 text-xl sm:text-2xl font-semibold text-gray-800">
          {t('errors.accessDenied')}
        </h2>

        <p className="mb-6 sm:mb-8 text-sm sm:text-base text-gray-600">
          {t('errors.accessDeniedMessage')}
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button
            variant="outline"
            onClick={handleGoBack}
            className="inline-flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('errors.goBack')}
          </Button>

          <Button asChild className="inline-flex items-center gap-2">
            <Link to="/">
              <Home className="h-4 w-4" />
              {t('errors.goHome')}
            </Link>
          </Button>
        </div>

        <p className="mt-8 text-sm text-gray-500">
          {t('errors.needHelp')}{' '}
          <a
            href="mailto:support@wtdcare.com"
            className="text-primary hover:underline"
          >
            {t('errors.contactSupport')}
          </a>
        </p>
      </div>
    </div>
  )
}
